import { render, staticRenderFns } from "./UpdatePass.vue?vue&type=template&id=b7e49c5c&scoped=true"
import script from "./UpdatePass.vue?vue&type=script&lang=js"
export * from "./UpdatePass.vue?vue&type=script&lang=js"
import style0 from "./UpdatePass.vue?vue&type=style&index=0&id=b7e49c5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e49c5c",
  null
  
)

export default component.exports